import { StructureDocumentType } from "@ac-expo/api-types";
import { FileType } from "@prisma/client";
import { useIsMobile } from "@ui/utils";
import { ArrowRight, Download } from "lucide-react";
import { Button } from "../../Button";
import { ProductThumbnail } from "../../ProductThumbnail";

type DocumentCardProps = {
  document: StructureDocumentType;
  getFileUrl: (key?: string, type?: FileType, width?: number) => string;
};

export const DocumentCard = ({ document, getFileUrl }: DocumentCardProps) => {
  const isMobile = useIsMobile();
  const thumbnailUrl = getFileUrl(
    document?.thumbnail?.key,
    document?.thumbnail?.type,
    200,
  );

  const isLink = !!document.link;
  const isPdf = !!document.file;

  const handleAction = () => {
    if (isLink && document.link) {
      window.open(document.link, "_blank", "noopener,noreferrer");
    } else if (isPdf && document.file) {
      const fileUrl = getFileUrl(document.file.key, document.file.type);
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="flex gap-4 rounded-xl border border-gray-200 bg-white max-md:gap-2 h-40">
      <ProductThumbnail
        imageUrl={thumbnailUrl}
        altContent={document?.name ?? "Document"}
        className="w-40 flex-shrink-0"
      />

      <div className="flex flex-col gap-2 py-2 px-4 min-w-0 justify-between w-fit">
        <h3 className="text-sm text-stone-900 font-bold">{document.name}</h3>

        <div className="mt-auto">
          {isLink && (
            <Button
              variant="link"
              className="h-auto p-0 text-blue-600 font-normal"
              onClick={handleAction}
            >
              <span className="text-xs">Vers le document</span>
              <ArrowRight className="ml-1 size-3" />
            </Button>
          )}
          {isPdf && (
            <Button
              variant="outline-blue"
              size="sm"
              className="text-xs"
              onClick={handleAction}
            >
              <Download className="mr-1 size-4" />
              {isMobile ? "Télécharger" : "Télécharger le PDF"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
